import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledLoadingContainer = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'center',
}))`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
`;

export default StyledLoadingContainer;
